import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { ApplicationRoles } from '../components/users/user-roles';
import { TranslationService } from './translation.service';

@Injectable({
  providedIn: 'root'
})

export class ParticipantThemeService {
  username: string = '';
  applicationRole: ApplicationRoles | null;
  participantClassByRole: string = '';
  llttfPage: boolean = false;
  loggedUserDisplayName: string = '';
  bannerSubTitle: string = '';
  recommendedBy: string = '';
  courseButtonName: string = 'View All Courses';
  welcomeBBMessage = 'Welcome to BounceBack® Coached';
  welcomeLLTTFMessage = '';
  welcomeSelfGuidedMessage = 'Welcome to BounceBack® Self-Guided';
  welcomeBBSubtitleMessage = 'Learn skills to manage low mood, stress, and worry with the support of a coach. With the right tools and practice, you can bounce back to reclaim your mental health.';
  welcomeLLTTFSubtitleMessage = '';
  welcomeSelfGuidedSubtitleMessage = '';
  coachRecommendedCourseText = "Coach recommended courses for you";
  facilitatorRecommendedSessionText = "Facilitator recommended sessions for you";
  recommendedCourseText = "Recommended courses for you";
  courseButtonText="View All Courses";
  sessionButtonText = "View All Sessions";
  translation: any;

  constructor(private authservice: AuthService) {
    this.username = this.authservice.getUserLoginData().agentName;
    this.applicationRole = this.authservice.getAccessControl().participantLastActiveRole;
  }

  setThemeLabels(translation: any) {
    this.welcomeBBMessage = translation['welcomeBBMessage'];
    this.welcomeLLTTFMessage = translation['welcomeLLTTFMessage'];
    this.welcomeSelfGuidedMessage = translation['welcomeSelfGuidedMessage'];
    this.welcomeBBSubtitleMessage = translation['welcomeBBSubtitleMessage'];
    this.welcomeLLTTFSubtitleMessage = translation['welcomeLLTTFSubtitleMessage'];
    this.welcomeSelfGuidedSubtitleMessage = translation['welcomeSelfGuidedSubtitleMessage'];
    this.coachRecommendedCourseText = translation["coachRecommendedCourseText"];
    this.facilitatorRecommendedSessionText = translation["facilitatorRecommendedSessionText"];
    this.recommendedCourseText = translation["recommendedCourseText"];
    this.courseButtonText = translation["courseButtonText"];
    this.sessionButtonText = translation["sessionButtonText"];
  }

  setParticipantTheme() {
    switch(this.applicationRole)
    {
      case ApplicationRoles.BB_CoachedParticipant:
        this.llttfPage = false;
        this.participantClassByRole = "bb-coached-color";
        this.recommendedBy = this.coachRecommendedCourseText;
        this.loggedUserDisplayName = this.welcomeBBMessage + ", " + this.username;
        this.bannerSubTitle = this.welcomeBBSubtitleMessage;
        this.courseButtonName = this.courseButtonText;
        break;
      case ApplicationRoles.LLTTF_CoachedParticipant:
        this.llttfPage = true;
        this.participantClassByRole = "llttf-coached-color";
        this.recommendedBy = this.facilitatorRecommendedSessionText;
        this.loggedUserDisplayName = this.welcomeLLTTFMessage + ", " + this.username;
        this.bannerSubTitle = this.welcomeLLTTFSubtitleMessage;
        this.courseButtonName = this.sessionButtonText;
        break;
      case ApplicationRoles.BB_SelfGuidedParticipant:
        this.llttfPage = false;
        this.participantClassByRole = "bb-self-guided-color";
        this.recommendedBy = this.recommendedCourseText;
        this.loggedUserDisplayName = this.welcomeSelfGuidedMessage + ", " + this.username;
        this.bannerSubTitle = this.welcomeSelfGuidedSubtitleMessage;
        this.courseButtonName = this.courseButtonText;
        break;
      default:
        this.recommendedBy = "";
        break;
    }

  }
}
